import { withT } from "neetocommons/react-utils";
import { Dropdown } from "neetoui";

import MoreDropdownMenuItem from "./MenuItem";

const { MenuItem, Menu } = Dropdown;

const Submenu = withT(({ t, label, key, ...menuItemProps }) => (
  <Dropdown
    appendTo="parent"
    key={key}
    position="left"
    trigger="hover"
    customTarget={
      <MenuItem.Button aria-haspopup="menu" role="menuitem">
        {label}
      </MenuItem.Button>
    }
    {...menuItemProps.dropdownProps}
  >
    <Menu
      aria-label={t("neetoMolecules.moreDropdown.submenuAriaLabel", { label })}
      role="menu"
    >
      {menuItemProps.menuItems.map(
        ({ isVisible = true, key, ...menuItemProps }) => {
          if (!isVisible) return null;

          return <MoreDropdownMenuItem key={key} {...menuItemProps} />;
        }
      )}
    </Menu>
  </Dropdown>
));

export default Submenu;
